<template>
  <interview-questions-item
    v-for="(question, index) in props.questions"
    :key="question.id"
    :index="index"
    :question="question"
    :active-names="activeNames"
    @click="handleClick"
    @open-explain-rank="openExplainRank"
  />
</template>

<script lang="ts" setup>
import { TQuestion } from '~/features/question';

const props = defineProps({
  questions: {
    type: Array<TQuestion>,
    required: true,
  },
})
const emit = defineEmits(['open-explain-rank'])
const openExplainRank = (rank: string) => {
  emit('open-explain-rank', rank)
}

const activeNames = ref([])

const handleClick = (question) => {
  if (!activeNames.value.includes(question?.slug as never)) {
    activeNames.value.push(question?.slug as never)
  } else {
    activeNames.value.splice(
      activeNames.value.indexOf(question?.slug as never),
      1,
    )
  }
}
</script>
